import React from 'react';
import Sidebar from './sidebar';

const SideBarContainer = () => {
    return (
        <Sidebar/>
    )
}

export default SideBarContainer;